import aralRegion from "../assets/img/aral-region.jpg";
import unicefProgramme from "../assets/img/unicef-country-programme.jpg";
import unWaterConference from "../assets/img/un-water-conference-2028.jpg";
import tjIndependence35 from "../assets/img/tj-independence-35.jpg";

/**
 * Новости, зашитые в код.
 *
 * `listed: false` — запись не выводится в общем списке, но остаётся доступной
 * по прямой ссылке `/news/static/:id`. Так себя вели все старые записи,
 * поэтому поведение сохранено явным флагом, а не пустым массивом.
 */
export const STATIC_NEWS = [
  // ── Отдельные новости ──────────────────────────────────────────────────────
  {
    id: "2026-tj-independence-35",
    listed: true,
    titleKey: "news_independence_35_title",
    date: "2026-09-09",
    image: tjIndependence35,
    excerptKey: "news_independence_35_text",
    bodyKey: "news_independence_35_full_text",
  },
  {
    id: "2026-un-water-conference-2028",
    listed: true,
    titleKey: "news_water_conference_title",
    date: "2026-09-02",
    image: unWaterConference,
    excerptKey: "news_water_conference_text",
    bodyKey: "news_water_conference_full_text",
  },
  {
    id: "2026-unicef-country-programme",
    listed: true,
    titleKey: "news_unicef_programme_title",
    date: "2026-09-02",
    image: unicefProgramme,
    excerptKey: "news_unicef_programme_text",
    bodyKey: "news_unicef_programme_full_text",
  },

  // ── По отчёту №1-13 за первый квартал 2026 года ────────────────────────────
  {
    id: "2026-q1-water-supply",
    listed: true,
    titleKey: "news_q1_2026_water_supply_title",
    date: "2026-03-31",
    excerptKey: "news_q1_2026_water_supply_text",
    bodyKey: "news_q1_2026_water_supply_full_text",
  },
  {
    id: "2026-q1-kaykhoni",
    listed: true,
    titleKey: "news_q1_2026_kaykhoni_title",
    date: "2026-03-30",
    excerptKey: "news_q1_2026_kaykhoni_text",
    bodyKey: "news_q1_2026_kaykhoni_full_text",
  },
  {
    id: "2026-glaciers-day-conference",
    listed: true,
    titleKey: "news_q1_2026_glaciers_day_title",
    date: "2026-03-12",
    excerptKey: "news_q1_2026_glaciers_day_text",
    bodyKey: "news_q1_2026_glaciers_day_full_text",
  },
  {
    id: "2026-tashkent-grant-meeting",
    listed: true,
    titleKey: "news_q1_2026_tashkent_title",
    date: "2026-03-06",
    excerptKey: "news_q1_2026_tashkent_text",
    bodyKey: "news_q1_2026_tashkent_full_text",
  },
  {
    id: "2026-ihe-delft-seminar",
    listed: true,
    titleKey: "news_q1_2026_ihe_delft_title",
    date: "2026-03-05",
    excerptKey: "news_q1_2026_ihe_delft_text",
    bodyKey: "news_q1_2026_ihe_delft_full_text",
  },
  {
    id: "2026-glaciers-center-conference",
    listed: true,
    titleKey: "news_q1_2026_glaciers_center_title",
    date: "2026-02-27",
    excerptKey: "news_q1_2026_glaciers_center_text",
    bodyKey: "news_q1_2026_glaciers_center_full_text",
  },
  {
    id: "2026-almaty-grant-meeting",
    listed: true,
    titleKey: "news_q1_2026_almaty_title",
    date: "2026-02-03",
    excerptKey: "news_q1_2026_almaty_text",
    bodyKey: "news_q1_2026_almaty_full_text",
  },

  // ── Ранние записи: доступны по прямой ссылке, в списке не показываются ─────
  {
    id: "s1",
    listed: false,
    titleKey: "aral_restoration_project",
    date: "2025-05-26",
    image: aralRegion,
    excerptKey: "aral_restoration_text",
    bodyKey: "aral_restoration_full_text",
  },
  {
    id: "s2",
    listed: false,
    titleKey: "aral_conference_dushanbe",
    date: "2025-05-20",
    image: aralRegion,
    excerptKey: "aral_conference_text",
    bodyKey: "aral_conference_full_text",
  },
  {
    id: "s3",
    listed: false,
    titleKey: "aral_water_initiative",
    date: "2025-05-15",
    image: aralRegion,
    excerptKey: "aral_water_initiative_text",
    bodyKey: "aral_water_initiative_full_text",
  },
  {
    id: "s4",
    listed: false,
    titleKey: "aral_community_program",
    date: "2025-05-10",
    image: aralRegion,
    excerptKey: "aral_community_program_text",
    bodyKey: "aral_community_program_full_text",
  },
  {
    id: "s5",
    listed: false,
    titleKey: "un_ocean_conference_2025",
    date: "2025-06-09",
    image: "https://live.staticflickr.com/65535/54577654631_395d858180_b.jpg",
    excerptKey: "un_ocean_conference_text",
    bodyKey: "un_ocean_conference_full_text",
  },
];

export const LISTED_STATIC_NEWS = STATIC_NEWS.filter((item) => item.listed);

export const STATIC_NEWS_BY_ID = Object.fromEntries(
  STATIC_NEWS.map((item) => [item.id, item]),
);

/** Приводим статичную новость к той же форме, что и данные из API. */
export function toArticle(item, t) {
  if (!item) return null;

  return {
    id: item.id,
    isStatic: true,
    title: t(item.titleKey, item.titleKey),
    date: item.date,
    excerpt: t(item.excerptKey, ""),
    body: t(item.bodyKey, "") || t(item.excerptKey, ""),
    image: item.image ?? null,
  };
}
